/* thingness — motion layer
   1. Scroll reveals via IntersectionObserver (no scroll listeners)
   2. Staggered children entrance (auto --i on direct children of [data-reveal-group])
   3. Magnetic CTA physics (pointer-fine only)
   Respects prefers-reduced-motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Stagger: assign --i to children of groups before observing ---- */
  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    var kids = group.children;
    for (var i = 0; i < kids.length; i++) {
      if (!kids[i].hasAttribute('data-reveal')) kids[i].setAttribute('data-reveal', '');
      if (!kids[i].style.getPropertyValue('--i')) kids[i].style.setProperty('--i', i);
    }
  });

  /* ---- Auto-stagger the "top sellers" product grid (built-in section) ---- */
  document.querySelectorAll('.ui-test-product-list').forEach(function (list) {
    var cards = list.querySelectorAll('.product-card, .resource-list__item, li');
    cards.forEach(function (card, i) {
      if (card.querySelector && (card.querySelector('.card-gallery') || card.classList.contains('product-card'))) {
        if (!card.hasAttribute('data-reveal')) card.setAttribute('data-reveal', '');
        if (!card.style.getPropertyValue('--i')) card.style.setProperty('--i', i % 8);
      }
    });
  });

  /* ---- Scroll reveal ---- */
  var targets = document.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-revealed'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---- Magnetic CTAs (skip touch / reduced-motion) ---- */
  if (!reduce && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    var STR = 0.28, MAX = 8; // strength + clamp(px)
    document.querySelectorAll('[data-magnetic]').forEach(function (btn) {
      var raf = null;
      function move(e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) * STR;
        var y = (e.clientY - (r.top + r.height / 2)) * STR;
        x = Math.max(-MAX, Math.min(MAX, x));
        y = Math.max(-MAX, Math.min(MAX, y));
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { btn.style.transform = 'translate(' + x + 'px,' + y + 'px)'; });
      }
      function reset() { if (raf) cancelAnimationFrame(raf); btn.style.transform = ''; }
      btn.addEventListener('pointermove', move);
      btn.addEventListener('pointerleave', reset);
    });
  }
})();
